export default __webpack_public_path__ + "static/media/feedback-header.4f59a895.svg";